module.exports = __webpack_public_path__ + "static/media/wcro-2021-logo.4b216a3f.png";